import { verifyLogin } from "util/cache";
import { useDocTitle } from "util/hooks";
import { useGetClassesQuery } from "util/rtk-api";

import { ClassroomCard, CreateClassroomCard, ArchivedClassesCard } from "components/classrooms/classroom-card";
import { CreateClassroomModal } from "components/classrooms/create-class-overlay";
import { ArchivedClassesOverlay } from "components/classrooms/archived-classes-overlay";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Class } from "types";
import 'css/pages/classrooms.css'

const TEST_CLASSROOMS = [
    {
        id: 1,
        name: 'Social Studies 9',
        period: 2,
        subject: 'Social Studies',
    },
    {
        id: 2,
        name: 'Social Studies 10',
        period: 3,
        subject: 'Social Studies',
    },
    {
        id: 3,
        name: 'World History',
        period: 4,
        subject: 'Social Studies',
    },
    {
        id: 4,
        name: 'Writing Intervention',
        period: 6,
        subject: 'English',
    },
]

export const Classrooms = () => {
    const [classrooms, setClassrooms] = useState<Class[]>([])
    const [showCreateClassroomModal, setShowCreateClassroomModal] = useState(false)
    const [showArchivedOverlay, setShowArchivedOverlay] = useState(false)
    const { data, isLoading, error } = useGetClassesQuery(undefined)

    const navigate = useNavigate()  

    useEffect(() => {
        verifyLogin(navigate)
        // TODO: Fetch classrooms from API
        if (!isLoading && data) {
            setClassrooms([...data.classes].sort((a, b) => a.name.localeCompare(b.name)))
        }
    }, [data, isLoading])

    useDocTitle('All for One - Classrooms')

    // err-11: a failed fetch used to render as "you have no classes"
    if (error) {
        return (
            <div className="classrooms">
                <h1>My Classrooms</h1>
                <p>We couldn't load your classes — they're safe. Check your connection and <a href="#retry" onClick={e => { e.preventDefault(); window.location.reload() }}>try again</a>.</p>
            </div>
        )
    }

    return (
         isLoading ?
            <div>Loading...</div> :
        <div className="classrooms">
            <h1>My Classrooms</h1>
            <div className="classrooms-grid">
                {classrooms.map((classroom) => (
                    <ClassroomCard key={classroom.classId} classroom={classroom} />
                ))}
                <ArchivedClassesCard onClick={() => setShowArchivedOverlay(true)} />
                <CreateClassroomCard handleCreateClassroom={() => { setShowCreateClassroomModal(true) }} />
            </div>
            {showCreateClassroomModal && <CreateClassroomModal setShowCreateClassroomModal={setShowCreateClassroomModal} />}
            {showArchivedOverlay && <ArchivedClassesOverlay onDismiss={() => setShowArchivedOverlay(false)} />}
        </div>
    )
}